<template>
  <div class="patrolPlanDetails commonWrap">
    <div style="width: 98%; height: 97%">
      <el-table :data="tableData"
        height="100%"
        border
        stripe
        style="width: 100%"
        :header-cell-style="{
          'font-weight': 'bold',
          color: '#333',
          'background-color': '#F7F7F7',
        }"
        :cell-style="cellStyle"
        @cell-click="cellClick">
        <el-table-column v-for="(v, i) in tabHead"
          :key="i"
          :prop="v.prop"
          :label="v.label"
          align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    detailData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tabHead: [],
      tableData: [],
    };
  },
  methods: {
    cellStyle(row) {
      if (row.column.label === "巡检点" || row.column.label == "设备保养进度") {
        return "color:#28CCCB;cursor: pointer";
      }
    },
    cellClick(row, column) {
      if (column.label == "巡检点" || column.label == "设备保养进度") {
        this.$emit("sentPoints", { index: 3, row: row });
      }
    },
    async getDetailData() {
      let res = await api.patrolPlanGetPlanDetail({
        planId: this.detailData.id,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data;
        this.tableData.map((v) => {
          v.tol = v.donePoint + v.notDoPoint;
          v.point = `${v.donePoint}/${v.donePoint + v.notDoPoint}`;
          v.completeness += "%";
        });
      }
    },
    getTabHead() {
      if (this.$route.path == "/patrolPlan") {
        this.tabHead = [
          { label: "计划巡检时间", prop: "beginAndEndTime" },
          { label: "巡检点", prop: "point" },
          { label: "计划巡检人", prop: "planStaffName" },
          { label: "实际巡检人", prop: "ipStaffName" },
          { label: "巡检完成度", prop: "completeness" },
        ];
      } else if (this.$route.path == "/maintainPlan") {
        this.tabHead = [
          { label: "设备数量", prop: "tol" },
          { label: "计划执行时间", prop: "beginAndEndTime" },
          { label: "设备保养进度", prop: "point" },
          { label: "计划保养人", prop: "planStaffName" },
          { label: "计划完成度", prop: "completeness" },
        ];
      }
    },
  },
  created() {
    this.getTabHead();
    if (this.detailData.id) {
      this.getDetailData();
    }
  },
};
</script>

<style lang="scss" scoped>
.patrolPlanDetails {
  width: 98%;
  height: 98%;
  margin: 0 auto;
  @include setFlexCenter;
}
</style>